import { Navigate, useLocation } from "react-router-dom";
import { continueCookieName, cookieDomain } from "environment";

import Cookies from "js-cookie";
import React from "react";
import { isLoggedIn } from "utils/api";

export const PrivateRoute = ({ children }) => {
  const location = useLocation();

  if (isLoggedIn()) {
    return children;
  } else {
    // window.sessionStorage.setItem("continue", props.location.pathname);
    Cookies.set(continueCookieName, location.pathname, {
      domain: cookieDomain,
    });

    return (
      <Navigate
        to={{
          pathname: "/employers/login",
        }}
        state={{ from: location }}
      />
    );
  }
};
